import axios from 'axios';
import { Nutrient } from 'views/feed-management/features/nutrients/types/nutrient.type';
import { NutrientsAttribute } from 'views/feed-management/features/nutrients/types/nutrients-attribute.type';

// GET
// Returns all nutrients.
// /ewosapi/v1/bestmix/nutrient
export const getFeedManagementNutrients = async (): Promise<Nutrient[]> => {
  const res = await axios.get<Nutrient[]>(`/ewosapi/v1/bestmix/nutrient`);
  return res.data;
};

// GET
// /ewosapi/v1/bestmix/Nutrientsattribute
// Returns list of Nutrientsattributes
export const getFeedManagementNutrientsAttribute = async (): Promise<NutrientsAttribute[]> => {
  const res = await axios.get<NutrientsAttribute[]>(`/ewosapi/v1/bestmix/nutritionsattribute`);
  return res.data;
};
